import React, { createContext, useContext, useState, ReactNode } from 'react';
import { profileData, ProfileData } from '../data/profileData';

type Language = 'en' | 'es';

interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  data: ProfileData;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Language>(() => {
    const savedLang = localStorage.getItem('system_lang');
    return (savedLang === 'en' || savedLang === 'es') ? savedLang : 'es';
  });

  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('system_lang', newLang);
  };

  const value = {
    lang,
    setLang,
    data: profileData[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
